// generated by Copilot and not reviewed line by line

package com.huanshankeji.compose.material.demo

import com.huanshankeji.compose.material.icons.Icon
import com.huanshankeji.compose.material.icons.Icons
import com.huanshankeji.compose.material.icons.automirrored.filled.*
import com.huanshankeji.compose.material.icons.filled.*

val coreFilledIconNamePairs: List<Pair<String, Icon>> = with(Icons.Filled) {
    listOf(
        "Account Box" to AccountBox,
        "Account Circle" to AccountCircle,
        "Add" to Add,
        "Add Circle" to AddCircle,
        "Arrow Back" to ArrowBack,
        "Arrow Drop Down" to ArrowDropDown,
        "Arrow Forward" to ArrowForward,
        "Build" to Build,
        "Call" to Call,
        "Check" to Check,
        "Check Circle" to CheckCircle,
        "Close" to Close,
        "Date Range" to DateRange,
        "Delete" to Delete,
        "Done" to Done,
        "Edit" to Edit,
        "Exit To App" to ExitToApp,
        "Face" to Face,
        "Favorite" to Favorite,
        "Home" to Home,
        "Info" to Info,
        "Keyboard Arrow Down" to KeyboardArrowDown,
        "Keyboard Arrow Left" to KeyboardArrowLeft,
        "Keyboard Arrow Right" to KeyboardArrowRight,
        "Keyboard Arrow Up" to KeyboardArrowUp,
        "List" to List,
        "Lock" to Lock,
        "Menu" to Menu,
        "More Vert" to MoreVert,
        "Notifications" to Notifications,
        "Person" to Person,
        "Place" to Place,
        "Play Arrow" to PlayArrow,
        "Refresh" to Refresh,
        "Search" to Search,
        "Send" to Send,
        "Settings" to Settings,
        "Share" to Share,
        "Shopping Cart" to ShoppingCart,
        "Star" to Star,
        "Thumb Up" to ThumbUp,
        "Warning" to Warning,
    )
}

val coreAutoMirroredFilledIconNamePairs: List<Pair<String, Icon>> = with(Icons.AutoMirrored.Filled) {
    listOf(
        "Arrow Back" to ArrowBack,
        "Arrow Forward" to ArrowForward,
        "Exit To App" to ExitToApp,
        "Keyboard Arrow Left" to KeyboardArrowLeft,
        "Keyboard Arrow Right" to KeyboardArrowRight,
        "List" to List,
        "Send" to Send,
    )
}

val extendedOnlyFilledIconNamePairs: List<Pair<String, Icon>> = with(Icons.Filled) {
    listOf(
        "Abc" to Abc,
        "Ac Unit" to AcUnit,
        "Accessibility" to Accessibility,
        "Accessibility New" to AccessibilityNew,
        "Accessible" to Accessible,
        "Accessible Forward" to AccessibleForward,
        "Account Balance" to AccountBalance,
        "Account Balance Wallet" to AccountBalanceWallet,
        "Account Tree" to AccountTree,
        "Adb" to Adb,
        "Add A Photo" to AddAPhoto,
        "Add Alert" to AddAlert,
        "Add Box" to AddBox,
        "Add Business" to AddBusiness,
        "Add Card" to AddCard,
        "Add Chart" to AddChart,
        "Add Comment" to AddComment,
        "Add Home" to AddHome,
        "Add Home Work" to AddHomeWork,
        "Add Link" to AddLink,
        "Add Location" to AddLocation,
        "Add Location Alt" to AddLocationAlt,
        "Add Moderator" to AddModerator,
        "Add Photo Alternate" to AddPhotoAlternate,
        "Add Reaction" to AddReaction,
        "Add Road" to AddRoad,
        "Add Shopping Cart" to AddShoppingCart,
        "Add Task" to AddTask,
        "Add To Drive" to AddToDrive,
        "Add To Photos" to AddToPhotos,
        "Add To Queue" to AddToQueue,
        "Adf Scanner" to AdfScanner,
        "Adjust" to Adjust,
        "Admin Panel Settings" to AdminPanelSettings,
        "Ads Click" to AdsClick,
        "Agriculture" to Agriculture,
        "Air" to Air,
        "Airline Seat Flat" to AirlineSeatFlat,
        "Airline Seat Flat Angled" to AirlineSeatFlatAngled,
        "Airline Seat Individual Suite" to AirlineSeatIndividualSuite,
        "Airline Seat Legroom Extra" to AirlineSeatLegroomExtra,
        "Airline Seat Legroom Normal" to AirlineSeatLegroomNormal,
        "Airline Seat Legroom Reduced" to AirlineSeatLegroomReduced,
        "Airline Seat Recline Extra" to AirlineSeatReclineExtra,
        "Airline Seat Recline Normal" to AirlineSeatReclineNormal,
        "Airline Stops" to AirlineStops,
        "Airlines" to Airlines,
        "Airplane Ticket" to AirplaneTicket,
        "Airplanemode Active" to AirplanemodeActive,
        "Airplanemode Inactive" to AirplanemodeInactive,
        "Airplay" to Airplay,
        "Airport Shuttle" to AirportShuttle,
        "Alarm" to Alarm,
        "Alarm Add" to AlarmAdd,
        "Alarm Off" to AlarmOff,
        "Alarm On" to AlarmOn,
        "Album" to Album,
        "Align Horizontal Center" to AlignHorizontalCenter,
        "Align Horizontal Left" to AlignHorizontalLeft,
        "Align Horizontal Right" to AlignHorizontalRight,
        "Align Vertical Bottom" to AlignVerticalBottom,
        "Align Vertical Center" to AlignVerticalCenter,
        "Align Vertical Top" to AlignVerticalTop,
        "All Inbox" to AllInbox,
        "All Inclusive" to AllInclusive,
        "All Out" to AllOut,
        "Alt Route" to AltRoute,
        "Alternate Email" to AlternateEmail,
        "Amp Stories" to AmpStories,
        "Analytics" to Analytics,
        "Anchor" to Anchor,
        "Android" to Android,
        "Animation" to Animation,
        "Apartment" to Apartment,
        "Api" to Api,
        "App Registration" to AppRegistration,
        "Approval" to Approval,
        "Apps" to Apps,
        "Apps Outage" to AppsOutage,
        "Architecture" to Architecture,
        "Archive" to Archive,
        "Area Chart" to AreaChart,
        "Arrow Back Ios" to ArrowBackIos,
        "Arrow Back Ios New" to ArrowBackIosNew,
        "Arrow Circle Down" to ArrowCircleDown,
        "Arrow Circle Left" to ArrowCircleLeft,
        "Arrow Circle Right" to ArrowCircleRight,
        "Arrow Circle Up" to ArrowCircleUp,
        "Arrow Downward" to ArrowDownward,
        "Arrow Drop Down Circle" to ArrowDropDownCircle,
        "Arrow Drop Up" to ArrowDropUp,
        "Arrow Forward Ios" to ArrowForwardIos,
        "Arrow Left" to ArrowLeft,
        "Arrow Outward" to ArrowOutward,
        "Arrow Right" to ArrowRight,
        "Arrow Right Alt" to ArrowRightAlt,
        "Arrow Upward" to ArrowUpward,
        "Art Track" to ArtTrack,
        "Article" to Article,
        "Aspect Ratio" to AspectRatio,
        "Assignment" to Assignment,
        "Assignment Ind" to AssignmentInd,
        "Assignment Late" to AssignmentLate,
        "Assignment Return" to AssignmentReturn,
        "Assignment Returned" to AssignmentReturned,
        "Assignment Turned In" to AssignmentTurnedIn,
        "Assist Walker" to AssistWalker,
        "Assistant" to Assistant,
        "Assistant Direction" to AssistantDirection,
        "Assured Workload" to AssuredWorkload,
        "Atm" to Atm,
        "Attach Email" to AttachEmail,
        "Attach File" to AttachFile,
        "Attach Money" to AttachMoney,
        "Attachment" to Attachment,
        "Attractions" to Attractions,
        "Attribution" to Attribution,
        "Audio File" to AudioFile,
        "Auto Awesome" to AutoAwesome,
        "Auto Awesome Mosaic" to AutoAwesomeMosaic,
        "Auto Awesome Motion" to AutoAwesomeMotion,
        "Auto Delete" to AutoDelete,
        "Auto Fix Normal" to AutoFixNormal,
        "Auto Fix Off" to AutoFixOff,
        "Auto Graph" to AutoGraph,
        "Auto Mode" to AutoMode,
        "Auto Stories" to AutoStories,
        "Autofps Select" to AutofpsSelect,
        "Autorenew" to Autorenew,
        "Av Timer" to AvTimer,
        "Baby Changing Station" to BabyChangingStation,
        "Back Hand" to BackHand,
        "Backpack" to Backpack,
        "Backspace" to Backspace,
        "Backup" to Backup,
        "Backup Table" to BackupTable,
        "Badge" to Badge,
        "Bakery Dining" to BakeryDining,
        "Balance" to Balance,
        "Balcony" to Balcony,
        "Ballot" to Ballot,
        "Bar Chart" to BarChart,
        "Batch Prediction" to BatchPrediction,
        "Bathroom" to Bathroom,
        "Bathtub" to Bathtub,
        "Battery0 Bar" to Battery0Bar,
        "Battery1 Bar" to Battery1Bar,
        "Battery2 Bar" to Battery2Bar,
        "Battery3 Bar" to Battery3Bar,
        "Battery4 Bar" to Battery4Bar,
        "Battery5 Bar" to Battery5Bar,
        "Battery6 Bar" to Battery6Bar,
        "Battery Alert" to BatteryAlert,
        "Battery Charging Full" to BatteryChargingFull,
        "Battery Full" to BatteryFull,
        "Battery Saver" to BatterySaver,
        "Battery Unknown" to BatteryUnknown,
        "Beach Access" to BeachAccess,
        "Bed" to Bed,
        "Bedroom Baby" to BedroomBaby,
        "Bedroom Child" to BedroomChild,
        "Bedroom Parent" to BedroomParent,
        "Bedtime" to Bedtime,
        "Bedtime Off" to BedtimeOff,
        "Beenhere" to Beenhere,
        "Bento" to Bento,
        "Bike Scooter" to BikeScooter,
        "Biotech" to Biotech,
        "Blender" to Blender,
        "Blind" to Blind,
        "Blinds" to Blinds,
        "Blinds Closed" to BlindsClosed,
        "Block" to Block,
        "Bloodtype" to Bloodtype,
        "Bluetooth" to Bluetooth,
        "Bluetooth Connected" to BluetoothConnected,
        "Bluetooth Disabled" to BluetoothDisabled,
        "Bluetooth Drive" to BluetoothDrive,
        "Bluetooth Searching" to BluetoothSearching,
        "Blur Circular" to BlurCircular,
        "Blur Linear" to BlurLinear,
        "Blur Off" to BlurOff,
        "Blur On" to BlurOn,
        "Bolt" to Bolt,
        "Book" to Book,
        "Bookmark" to Bookmark,
        "Bookmark Add" to BookmarkAdd,
        "Bookmark Added" to BookmarkAdded,
        "Bookmark Remove" to BookmarkRemove,
        "Bookmarks" to Bookmarks,
        "Border All" to BorderAll,
        "Border Bottom" to BorderBottom,
        "Border Clear" to BorderClear,
        "Border Color" to BorderColor,
        "Border Horizontal" to BorderHorizontal,
        "Border Inner" to BorderInner,
        "Border Left" to BorderLeft,
        "Border Outer" to BorderOuter,
        "Border Right" to BorderRight,
        "Border Style" to BorderStyle,
        "Border Top" to BorderTop,
        "Border Vertical" to BorderVertical,
        "Boy" to Boy,
        "Branding Watermark" to BrandingWatermark,
        "Breakfast Dining" to BreakfastDining,
        "Brightness1" to Brightness1,
        "Brightness2" to Brightness2,
        "Brightness3" to Brightness3,
        "Brightness4" to Brightness4,
        "Brightness5" to Brightness5,
        "Brightness6" to Brightness6,
        "Brightness7" to Brightness7,
        "Brightness Auto" to BrightnessAuto,
        "Brightness High" to BrightnessHigh,
        "Brightness Low" to BrightnessLow,
        "Brightness Medium" to BrightnessMedium,
        "Broadcast On Home" to BroadcastOnHome,
        "Broadcast On Personal" to BroadcastOnPersonal,
        "Broken Image" to BrokenImage,
        "Browse Gallery" to BrowseGallery,
        "Browser Updated" to BrowserUpdated,
        "Brunch Dining" to BrunchDining,
        "Brush" to Brush,
        "Bubble Chart" to BubbleChart,
        "Bug Report" to BugReport,
        "Build Circle" to BuildCircle,
        "Bungalow" to Bungalow,
        "Burst Mode" to BurstMode,
        "Bus Alert" to BusAlert,
        "Business Center" to BusinessCenter,
        "Cabin" to Cabin,
        "Cable" to Cable,
        "Cached" to Cached,
        "Cake" to Cake,
        "Calculate" to Calculate,
        "Calendar Month" to CalendarMonth,
        "Calendar Today" to CalendarToday,
        "Calendar View Day" to CalendarViewDay,
        "Calendar View Month" to CalendarViewMonth,
        "Calendar View Week" to CalendarViewWeek,
        "Call End" to CallEnd,
        "Call Made" to CallMade,
        "Call Merge" to CallMerge,
        "Call Missed" to CallMissed,
        "Call Missed Outgoing" to CallMissedOutgoing,
        "Call Received" to CallReceived,
        "Call Split" to CallSplit,
        "Call To Action" to CallToAction,
        "Camera" to Camera,
        "Camera Enhance" to CameraEnhance,
        "Camera Indoor" to CameraIndoor,
        "Camera Outdoor" to CameraOutdoor,
        "Camera Roll" to CameraRoll,
        "Cameraswitch" to Cameraswitch,
        "Campaign" to Campaign,
        "Cancel" to Cancel,
        "Cancel Presentation" to CancelPresentation,
        "Cancel Schedule Send" to CancelScheduleSend,
        "Candlestick Chart" to CandlestickChart,
        "Car Crash" to CarCrash,
        "Car Rental" to CarRental,
        "Car Repair" to CarRepair,
        "Card Membership" to CardMembership,
        "Card Travel" to CardTravel,
        "Carpenter" to Carpenter,
        "Cases" to Cases,
        "Casino" to Casino,
        "Cast" to Cast,
        "Cast Connected" to CastConnected,
        "Cast For Education" to CastForEducation,
        "Castle" to Castle,
        "Category" to Category,
        "Celebration" to Celebration,
        "Cell Tower" to CellTower,
        "Cell Wifi" to CellWifi,
        "Center Focus Strong" to CenterFocusStrong,
        "Center Focus Weak" to CenterFocusWeak,
        "Chair" to Chair,
        "Chair Alt" to ChairAlt,
        "Chalet" to Chalet,
        "Change Circle" to ChangeCircle,
        "Change History" to ChangeHistory,
        "Chat" to Chat,
        "Chat Bubble" to ChatBubble,
        "Check Box" to CheckBox,
        "Check Box Outline Blank" to CheckBoxOutlineBlank,
        "Checklist" to Checklist,
        "Checklist Rtl" to ChecklistRtl,
        "Checkroom" to Checkroom,
        "Chevron Left" to ChevronLeft,
        "Chevron Right" to ChevronRight,
        "Child Care" to ChildCare,
        "Child Friendly" to ChildFriendly,
        "Chrome Reader Mode" to ChromeReaderMode,
        "Church" to Church,
        "Circle" to Circle,
        "Circle Notifications" to CircleNotifications,
        "Clean Hands" to CleanHands,
        "Cleaning Services" to CleaningServices,
        "Clear All" to ClearAll,
        "Close Fullscreen" to CloseFullscreen,
        "Closed Caption" to ClosedCaption,
        "Closed Caption Disabled" to ClosedCaptionDisabled,
        "Cloud" to Cloud,
        "Cloud Circle" to CloudCircle,
        "Cloud Done" to CloudDone,
        "Cloud Download" to CloudDownload,
        "Cloud Off" to CloudOff,
        "Cloud Sync" to CloudSync,
        "Cloud Upload" to CloudUpload,
        "Co2" to Co2,
        "Co Present" to CoPresent,
        "Code" to Code,
        "Code Off" to CodeOff,
        "Coffee" to Coffee,
        "Coffee Maker" to CoffeeMaker,
        "Collections Bookmark" to CollectionsBookmark,
        "Colorize" to Colorize,
        "Comment" to Comment,
        "Comment Bank" to CommentBank,
        "Comments Disabled" to CommentsDisabled,
        "Commit" to Commit,
        "Commute" to Commute,
        "Compare" to Compare,
        "Compare Arrows" to CompareArrows,
        "Compass Calibration" to CompassCalibration,
        "Compost" to Compost,
        "Compress" to Compress,
        "Computer" to Computer,
        "Confirmation Number" to ConfirmationNumber,
        "Connect Without Contact" to ConnectWithoutContact,
        "Connected Tv" to ConnectedTv,
        "Connecting Airports" to ConnectingAirports,
        "Construction" to Construction,
        "Contact Emergency" to ContactEmergency,
        "Contact Mail" to ContactMail,
        "Contact Page" to ContactPage,
        "Contact Phone" to ContactPhone,
        "Contact Support" to ContactSupport,
        "Contactless" to Contactless,
        "Contacts" to Contacts,
        "Content Copy" to ContentCopy,
        "Content Cut" to ContentCut,
        "Content Paste" to ContentPaste,
        "Content Paste Go" to ContentPasteGo,
        "Content Paste Off" to ContentPasteOff,
        "Content Paste Search" to ContentPasteSearch,
        "Contrast" to Contrast,
        "Control Camera" to ControlCamera,
        "Control Point Duplicate" to ControlPointDuplicate,
        "Cookie" to Cookie,
        "Copy All" to CopyAll,
        "Copyright" to Copyright,
        "Coronavirus" to Coronavirus,
        "Corporate Fare" to CorporateFare,
        "Cottage" to Cottage,
        "Countertops" to Countertops,
        "Create New Folder" to CreateNewFolder,
        "Credit Card" to CreditCard,
        "Credit Card Off" to CreditCardOff,
        "Credit Score" to CreditScore,
        "Crib" to Crib,
        "Crisis Alert" to CrisisAlert,
        "Crop" to Crop,
        "Crop169" to Crop169,
        "Crop32" to Crop32,
        "Crop54" to Crop54,
        "Crop75" to Crop75,
        "Crop Free" to CropFree,
        "Crop Landscape" to CropLandscape,
        "Crop Portrait" to CropPortrait,
        "Crop Rotate" to CropRotate,
        "Crop Square" to CropSquare,
        "Cruelty Free" to CrueltyFree,
        "Css" to Css,
        "Currency Bitcoin" to CurrencyBitcoin,
        "Currency Exchange" to CurrencyExchange,
        "Currency Franc" to CurrencyFranc,
        "Currency Lira" to CurrencyLira,
        "Currency Pound" to CurrencyPound,
        "Currency Ruble" to CurrencyRuble,
        "Currency Rupee" to CurrencyRupee,
        "Currency Yen" to CurrencyYen,
        "Currency Yuan" to CurrencyYuan,
        "Curtains" to Curtains,
        "Curtains Closed" to CurtainsClosed,
        "Cyclone" to Cyclone,
        "Dangerous" to Dangerous,
        "Dark Mode" to DarkMode,
        "Dashboard" to Dashboard,
        "Dashboard Customize" to DashboardCustomize,
        "Data Array" to DataArray,
        "Data Exploration" to DataExploration,
        "Data Object" to DataObject,
        "Data Saver On" to DataSaverOn,
        "Data Thresholding" to DataThresholding,
        "Data Usage" to DataUsage,
        "Dataset" to Dataset,
        "Dataset Linked" to DatasetLinked,
        "Deblur" to Deblur,
        "Deck" to Deck,
        "Dehaze" to Dehaze,
        "Delete Forever" to DeleteForever,
        "Delete Sweep" to DeleteSweep,
        "Density Large" to DensityLarge,
        "Density Medium" to DensityMedium,
        "Density Small" to DensitySmall,
        "Departure Board" to DepartureBoard,
        "Description" to Description,
        "Deselect" to Deselect,
        "Design Services" to DesignServices,
        "Desk" to Desk,
        "Desktop Access Disabled" to DesktopAccessDisabled,
        "Desktop Mac" to DesktopMac,
        "Desktop Windows" to DesktopWindows,
        "Details" to Details,
        "Developer Board" to DeveloperBoard,
        "Developer Board Off" to DeveloperBoardOff,
        "Device Hub" to DeviceHub,
        "Device Thermostat" to DeviceThermostat,
        "Devices" to Devices,
        "Devices Fold" to DevicesFold,
        "Devices Other" to DevicesOther,
        "Dialer Sip" to DialerSip,
        "Dialpad" to Dialpad,
        "Diamond" to Diamond,
        "Difference" to Difference,
        "Dining" to Dining,
        "Dinner Dining" to DinnerDining,
        "Directions" to Directions,
        "Directions Bike" to DirectionsBike,
        "Directions Boat" to DirectionsBoat,
        "Directions Bus" to DirectionsBus,
        "Directions Car" to DirectionsCar,
        "Directions Off" to DirectionsOff,
        "Directions Railway" to DirectionsRailway,
        "Directions Run" to DirectionsRun,
        "Directions Subway" to DirectionsSubway,
        "Directions Walk" to DirectionsWalk,
        "Dirty Lens" to DirtyLens,
        "Disabled By Default" to DisabledByDefault,
        "Disabled Visible" to DisabledVisible,
        "Disc Full" to DiscFull,
        "Display Settings" to DisplaySettings,
        "Diversity1" to Diversity1,
        "Diversity2" to Diversity2,
        "Diversity3" to Diversity3,
        "Dns" to Dns,
        "Do Not Disturb" to DoNotDisturb,
        "Do Not Disturb Off" to DoNotDisturbOff,
        "Do Not Disturb On" to DoNotDisturbOn,
        "Do Not Disturb On Total Silence" to DoNotDisturbOnTotalSilence,
        "Do Not Step" to DoNotStep,
        "Do Not Touch" to DoNotTouch,
        "Dock" to Dock,
        "Document Scanner" to DocumentScanner,
        "Domain" to Domain,
        "Domain Add" to DomainAdd,
        "Domain Disabled" to DomainDisabled,
        "Domain Verification" to DomainVerification,
        "Done All" to DoneAll,
        "Done Outline" to DoneOutline,
        "Donut Large" to DonutLarge,
        "Donut Small" to DonutSmall,
        "Door Back" to DoorBack,
        "Door Front" to DoorFront,
        "Door Sliding" to DoorSliding,
        "Doorbell" to Doorbell,
        "Double Arrow" to DoubleArrow,
        "Downhill Skiing" to DownhillSkiing,
        "Download" to Download,
        "Download Done" to DownloadDone,
        "Download For Offline" to DownloadForOffline,
        "Downloading" to Downloading,
        "Drafts" to Drafts,
        "Drag Handle" to DragHandle,
        "Drag Indicator" to DragIndicator,
        "Draw" to Draw,
        "Drive File Move" to DriveFileMove,
        "Drive File Rename Outline" to DriveFileRenameOutline,
        "Drive Folder Upload" to DriveFolderUpload,
        "Dry" to Dry,
        "Dry Cleaning" to DryCleaning,
        "Duo" to Duo,
        "Dvr" to Dvr,
        "Dynamic Feed" to DynamicFeed,
        "Dynamic Form" to DynamicForm,
        "E Mobiledata" to EMobiledata,
        "Earbuds" to Earbuds,
        "Earbuds Battery" to EarbudsBattery,
        "East" to East,
        "Eco" to Eco,
        "Edit Attributes" to EditAttributes,
        "Edit Calendar" to EditCalendar,
        "Edit Location" to EditLocation,
        "Edit Location Alt" to EditLocationAlt,
        "Edit Note" to EditNote,
        "Edit Notifications" to EditNotifications,
        "Edit Off" to EditOff,
        "Edit Road" to EditRoad,
        "Egg" to Egg,
        "Egg Alt" to EggAlt,
        "Eject" to Eject,
        "Elderly" to Elderly,
        "Elderly Woman" to ElderlyWoman,
        "Electric Bike" to ElectricBike,
        "Electric Bolt" to ElectricBolt,
        "Electric Car" to ElectricCar,
        "Electric Meter" to ElectricMeter,
        "Electric Moped" to ElectricMoped,
        "Electric Rickshaw" to ElectricRickshaw,
        "Electric Scooter" to ElectricScooter,
        "Electrical Services" to ElectricalServices,
        "Elevator" to Elevator,
        "Emergency" to Emergency,
        "Emergency Recording" to EmergencyRecording,
        "Emergency Share" to EmergencyShare,
        "Emoji Food Beverage" to EmojiFoodBeverage,
        "Emoji Nature" to EmojiNature,
        "Emoji Objects" to EmojiObjects,
        "Emoji People" to EmojiPeople,
        "Emoji Symbols" to EmojiSymbols,
        "Emoji Transportation" to EmojiTransportation,
        "Energy Savings Leaf" to EnergySavingsLeaf,
        "Engineering" to Engineering,
        "Enhanced Encryption" to EnhancedEncryption,
        "Equalizer" to Equalizer,
        "Error" to Error,
        "Escalator" to Escalator,
        "Escalator Warning" to EscalatorWarning,
        "Euro" to Euro,
        "Euro Symbol" to EuroSymbol,
        "Ev Station" to EvStation,
        "Event" to Event,
        "Event Available" to EventAvailable,
        "Event Busy" to EventBusy,
        "Event Note" to EventNote,
        "Event Repeat" to EventRepeat,
        "Event Seat" to EventSeat,
        "Expand" to Expand,
        "Expand Circle Down" to ExpandCircleDown,
        "Expand Less" to ExpandLess,
        "Expand More" to ExpandMore,
        "Explicit" to Explicit,
        "Explore" to Explore,
        "Explore Off" to ExploreOff,
        "Exposure" to Exposure,
        "Exposure Neg1" to ExposureNeg1,
        "Exposure Neg2" to ExposureNeg2,
        "Exposure Plus1" to ExposurePlus1,
        "Exposure Plus2" to ExposurePlus2,
        "Exposure Zero" to ExposureZero,
        "Extension" to Extension,
        "Extension Off" to ExtensionOff,
        "Face2" to Face2,
        "Face3" to Face3,
        "Face4" to Face4,
        "Face5" to Face5,
        "Face6" to Face6,
        "Face Retouching Natural" to FaceRetouchingNatural,
        "Face Retouching Off" to FaceRetouchingOff,
        "Fact Check" to FactCheck,
        "Factory" to Factory,
        "Family Restroom" to FamilyRestroom,
        "Fast Forward" to FastForward,
        "Fast Rewind" to FastRewind,
        "Fastfood" to Fastfood,
        "Fax" to Fax,
        "Featured Play List" to FeaturedPlayList,
        "Featured Video" to FeaturedVideo,
        "Feed" to Feed,
        "Female" to Female,
        "Fence" to Fence,
        "Festival" to Festival,
        "Fiber Dvr" to FiberDvr,
        "Fiber Manual Record" to FiberManualRecord,
        "Fiber New" to FiberNew,
        "Fiber Pin" to FiberPin,
        "Fiber Smart Record" to FiberSmartRecord,
        "File Copy" to FileCopy,
        "File Download Off" to FileDownloadOff,
        "File Open" to FileOpen,
        "File Present" to FilePresent,
        "Filter" to Filter,
        "Filter1" to Filter1,
        "Filter2" to Filter2,
        "Filter3" to Filter3,
        "Filter4" to Filter4,
        "Filter5" to Filter5,
        "Filter6" to Filter6,
        "Filter7" to Filter7,
        "Filter8" to Filter8,
        "Filter9" to Filter9,
        "Filter9 Plus" to Filter9Plus,
        "Filter Alt" to FilterAlt,
        "Filter Alt Off" to FilterAltOff,
        "Filter B And W" to FilterBAndW,
        "Filter Center Focus" to FilterCenterFocus,
        "Filter Drama" to FilterDrama,
        "Filter Frames" to FilterFrames,
        "Filter Hdr" to FilterHdr,
        "Filter List" to FilterList,
        "Filter List Off" to FilterListOff,
        "Filter None" to FilterNone,
        "Filter Tilt Shift" to FilterTiltShift,
        "Filter Vintage" to FilterVintage,
        "Find In Page" to FindInPage,
        "Find Replace" to FindReplace,
        "Fingerprint" to Fingerprint,
        "Fire Extinguisher" to FireExtinguisher,
        "Fire Truck" to FireTruck,
        "Fireplace" to Fireplace,
        "First Page" to FirstPage,
        "Fit Screen" to FitScreen,
        "Fitness Center" to FitnessCenter,
        "Flag" to Flag,
        "Flag Circle" to FlagCircle,
        "Flaky" to Flaky,
        "Flare" to Flare,
        "Flash Auto" to FlashAuto,
        "Flash Off" to FlashOff,
        "Flash On" to FlashOn,
        "Flashlight Off" to FlashlightOff,
        "Flashlight On" to FlashlightOn,
        "Flatware" to Flatware,
        "Flight" to Flight,
        "Flight Class" to FlightClass,
        "Flight Land" to FlightLand,
        "Flight Takeoff" to FlightTakeoff,
        "Flip" to Flip,
        "Flip Camera Android" to FlipCameraAndroid,
        "Flip Camera Ios" to FlipCameraIos,
        "Flip To Back" to FlipToBack,
        "Flip To Front" to FlipToFront,
        "Flood" to Flood,
        "Flutter Dash" to FlutterDash,
        "Fmd Bad" to FmdBad,
        "Folder" to Folder,
        "Folder Copy" to FolderCopy,
        "Folder Delete" to FolderDelete,
        "Folder Off" to FolderOff,
        "Folder Open" to FolderOpen,
        "Folder Shared" to FolderShared,
        "Folder Special" to FolderSpecial,
        "Folder Zip" to FolderZip,
        "Follow The Signs" to FollowTheSigns,
        "Font Download" to FontDownload,
        "Font Download Off" to FontDownloadOff,
        "Food Bank" to FoodBank,
        "Forest" to Forest,
        "Fork Left" to ForkLeft,
        "Fork Right" to ForkRight,
        "Format Align Center" to FormatAlignCenter,
        "Format Align Justify" to FormatAlignJustify,
        "Format Align Left" to FormatAlignLeft,
        "Format Align Right" to FormatAlignRight,
        "Format Bold" to FormatBold,
        "Format Clear" to FormatClear,
        "Format Color Fill" to FormatColorFill,
        "Format Color Reset" to FormatColorReset,
        "Format Color Text" to FormatColorText,
        "Format Indent Decrease" to FormatIndentDecrease,
        "Format Indent Increase" to FormatIndentIncrease,
        "Format Italic" to FormatItalic,
        "Format Line Spacing" to FormatLineSpacing,
        "Format List Bulleted" to FormatListBulleted,
        "Format List Numbered" to FormatListNumbered,
        "Format List Numbered Rtl" to FormatListNumberedRtl,
        "Format Overline" to FormatOverline,
        "Format Paint" to FormatPaint,
        "Format Quote" to FormatQuote,
        "Format Shapes" to FormatShapes,
        "Format Size" to FormatSize,
        "Format Strikethrough" to FormatStrikethrough,
        "Format Textdirection L To R" to FormatTextdirectionLToR,
        "Format Textdirection R To L" to FormatTextdirectionRToL,
        "Format Underlined" to FormatUnderlined,
        "Fort" to Fort,
        "Forum" to Forum,
        "Forward" to Forward,
        "Forward10" to Forward10,
        "Forward30" to Forward30,
        "Forward5" to Forward5,
        "Forward To Inbox" to ForwardToInbox,
        "Foundation" to Foundation,
        "Free Cancellation" to FreeCancellation,
        "Front Hand" to FrontHand,
        "Fullscreen" to Fullscreen,
        "Fullscreen Exit" to FullscreenExit,
        "Functions" to Functions,
        "G Mobiledata" to GMobiledata,
        "G Translate" to GTranslate,
        "Gamepad" to Gamepad,
        "Garage" to Garage,
        "Gas Meter" to GasMeter,
        "Gavel" to Gavel,
        "Generating Tokens" to GeneratingTokens,
        "Gesture" to Gesture,
        "Gif" to Gif,
        "Gif Box" to GifBox,
        "Girl" to Girl,
        "Gite" to Gite,
        "Golf Course" to GolfCourse,
        "Gpp Bad" to GppBad,
        "Gpp Maybe" to GppMaybe,
        "Gradient" to Gradient,
        "Grading" to Grading,
        "Grain" to Grain,
        "Graphic Eq" to GraphicEq,
        "Grass" to Grass,
        "Grid3x3" to Grid3x3,
        "Grid4x4" to Grid4x4,
        "Grid Goldenratio" to GridGoldenratio,
        "Grid Off" to GridOff,
        "Grid On" to GridOn,
        "Grid View" to GridView,
        "Group" to Group,
        "Group Add" to GroupAdd,
        "Group Off" to GroupOff,
        "Group Remove" to GroupRemove,
        "Group Work" to GroupWork,
        "Groups" to Groups,
        "Groups2" to Groups2,
        "Groups3" to Groups3,
        "H Mobiledata" to HMobiledata,
        "H Plus Mobiledata" to HPlusMobiledata,
        "Hail" to Hail,
        "Handshake" to Handshake,
        "Handyman" to Handyman,
        "Hardware" to Hardware,
        "Hd" to Hd,
        "Hdr Auto" to HdrAuto,
        "Hdr Auto Select" to HdrAutoSelect,
        "Hdr Enhanced Select" to HdrEnhancedSelect,
        "Hdr Off" to HdrOff,
        "Hdr Off Select" to HdrOffSelect,
        "Hdr On" to HdrOn,
        "Hdr On Select" to HdrOnSelect,
        "Hdr Plus" to HdrPlus,
        "Hdr Strong" to HdrStrong,
        "Hdr Weak" to HdrWeak,
        "Headphones" to Headphones,
        "Headphones Battery" to HeadphonesBattery,
        "Headset Mic" to HeadsetMic,
        "Headset Off" to HeadsetOff,
        "Healing" to Healing,
        "Health And Safety" to HealthAndSafety,
        "Hearing" to Hearing,
        "Hearing Disabled" to HearingDisabled,
        "Heart Broken" to HeartBroken,
        "Heat Pump" to HeatPump,
        "Height" to Height,
        "Help" to Help,
        "Help Center" to HelpCenter,
        "Hevc" to Hevc,
        "Hexagon" to Hexagon,
        "Hide Image" to HideImage,
        "Hide Source" to HideSource,
        "High Quality" to HighQuality,
        "Highlight" to Highlight,
        "Hiking" to Hiking,
        "History" to History,
        "History Edu" to HistoryEdu,
        "History Toggle Off" to HistoryToggleOff,
        "Hive" to Hive,
        "Hls" to Hls,
        "Hls Off" to HlsOff,
        "Holiday Village" to HolidayVillage,
        "Home Max" to HomeMax,
        "Home Mini" to HomeMini,
        "Home Repair Service" to HomeRepairService,
        "Home Work" to HomeWork,
        "Horizontal Distribute" to HorizontalDistribute,
        "Horizontal Rule" to HorizontalRule,
        "Horizontal Split" to HorizontalSplit,
        "Hot Tub" to HotTub,
        "Hotel" to Hotel,
        "Hotel Class" to HotelClass,
        "Hourglass Bottom" to HourglassBottom,
        "Hourglass Disabled" to HourglassDisabled,
        "Hourglass Empty" to HourglassEmpty,
        "Hourglass Full" to HourglassFull,
        "Hourglass Top" to HourglassTop,
        "House" to House,
        "House Siding" to HouseSiding,
        "Houseboat" to Houseboat,
        "How To Reg" to HowToReg,
        "How To Vote" to HowToVote,
        "Html" to Html,
        "Http" to Http,
        "Hub" to Hub,
        "Hvac" to Hvac,
        "Ice Skating" to IceSkating,
        "Icecream" to Icecream,
        "Image" to Image,
        "Image Aspect Ratio" to ImageAspectRatio,
        "Image Not Supported" to ImageNotSupported,
        "Image Search" to ImageSearch,
        "Imagesearch Roller" to ImagesearchRoller,
        "Import Contacts" to ImportContacts,
        "Important Devices" to ImportantDevices,
        "Inbox" to Inbox,
        "Incomplete Circle" to IncompleteCircle,
        "Indeterminate Check Box" to IndeterminateCheckBox,
        "Input" to Input,
        "Insert Chart" to InsertChart,
        "Insert Page Break" to InsertPageBreak,
        "Insights" to Insights,
        "Install Desktop" to InstallDesktop,
        "Integration Instructions" to IntegrationInstructions,
        "Interests" to Interests,
        "Interpreter Mode" to InterpreterMode,
        "Inventory" to Inventory,
        "Inventory2" to Inventory2,
        "Invert Colors" to InvertColors,
        "Invert Colors Off" to InvertColorsOff,
        "Ios Share" to IosShare,
        "Iron" to Iron,
        "Javascript" to Javascript,
        "Join Inner" to JoinInner,
        "Join Left" to JoinLeft,
        "Join Right" to JoinRight,
        "Kayaking" to Kayaking,
        "Kebab Dining" to KebabDining,
        "Key" to Key,
        "Key Off" to KeyOff,
        "Keyboard" to Keyboard,
        "Keyboard Alt" to KeyboardAlt,
        "Keyboard Backspace" to KeyboardBackspace,
        "Keyboard Capslock" to KeyboardCapslock,
        "Keyboard Command Key" to KeyboardCommandKey,
        "Keyboard Control Key" to KeyboardControlKey,
        "Keyboard Double Arrow Down" to KeyboardDoubleArrowDown,
        "Keyboard Double Arrow Left" to KeyboardDoubleArrowLeft,
        "Keyboard Double Arrow Right" to KeyboardDoubleArrowRight,
        "Keyboard Double Arrow Up" to KeyboardDoubleArrowUp,
        "Keyboard Hide" to KeyboardHide,
        "Keyboard Option Key" to KeyboardOptionKey,
        "Keyboard Return" to KeyboardReturn,
        "Keyboard Tab" to KeyboardTab,
        "King Bed" to KingBed,
        "Kitchen" to Kitchen,
        "Kitesurfing" to Kitesurfing,
        "Label" to Label,
        "Label Important" to LabelImportant,
        "Label Off" to LabelOff,
        "Lan" to Lan,
        "Landscape" to Landscape,
        "Landslide" to Landslide,
        "Language" to Language,
        "Laptop Chromebook" to LaptopChromebook,
        "Laptop Mac" to LaptopMac,
        "Laptop Windows" to LaptopWindows,
        "Last Page" to LastPage,
        "Layers" to Layers,
        "Layers Clear" to LayersClear,
        "Leaderboard" to Leaderboard,
        "Leak Add" to LeakAdd,
        "Leak Remove" to LeakRemove,
        "Legend Toggle" to LegendToggle,
        "Lens Blur" to LensBlur,
        "Library Add" to LibraryAdd,
        "Library Add Check" to LibraryAddCheck,
        "Library Books" to LibraryBooks,
        "Library Music" to LibraryMusic,
        "Light" to Light,
        "Light Mode" to LightMode,
        "Lightbulb" to Lightbulb,
        "Lightbulb Circle" to LightbulbCircle,
        "Line Axis" to LineAxis,
        "Line Style" to LineStyle,
        "Line Weight" to LineWeight,
        "Linear Scale" to LinearScale,
        "Link" to Link,
        "Link Off" to LinkOff,
        "Linked Camera" to LinkedCamera,
        "Liquor" to Liquor,
        "List Alt" to ListAlt,
        "Live Help" to LiveHelp,
        "Live Tv" to LiveTv,
        "Living" to Living,
        "Local Activity" to LocalActivity,
        "Local Atm" to LocalAtm,
        "Local Bar" to LocalBar,
        "Local Cafe" to LocalCafe,
        "Local Car Wash" to LocalCarWash,
        "Local Convenience Store" to LocalConvenienceStore,
        "Local Drink" to LocalDrink,
        "Local Fire Department" to LocalFireDepartment,
        "Local Florist" to LocalFlorist,
        "Local Gas Station" to LocalGasStation,
        "Local Hospital" to LocalHospital,
        "Local Laundry Service" to LocalLaundryService,
        "Local Library" to LocalLibrary,
        "Local Mall" to LocalMall,
        "Local Parking" to LocalParking,
        "Local Pharmacy" to LocalPharmacy,
        "Local Pizza" to LocalPizza,
        "Local Police" to LocalPolice,
        "Local Post Office" to LocalPostOffice,
        "Local See" to LocalSee,
        "Local Shipping" to LocalShipping,
        "Local Taxi" to LocalTaxi,
        "Location City" to LocationCity,
        "Location Disabled" to LocationDisabled,
        "Location Off" to LocationOff,
        "Location Searching" to LocationSearching,
        "Lock Clock" to LockClock,
        "Lock Open" to LockOpen,
        "Lock Person" to LockPerson,
        "Lock Reset" to LockReset,
        "Login" to Login,
        "Logo Dev" to LogoDev,
        "Logout" to Logout,
        "Looks" to Looks,
        "Looks3" to Looks3,
        "Looks4" to Looks4,
        "Looks5" to Looks5,
        "Looks6" to Looks6,
        "Looks One" to LooksOne,
        "Looks Two" to LooksTwo,
        "Loupe" to Loupe,
        "Low Priority" to LowPriority,
        "Loyalty" to Loyalty,
        "Lte Mobiledata" to LteMobiledata,
        "Lte Plus Mobiledata" to LtePlusMobiledata,
        "Luggage" to Luggage,
        "Lunch Dining" to LunchDining,
        "Lyrics" to Lyrics,
        "Macro Off" to MacroOff,
        "Mail" to Mail,
        "Mail Lock" to MailLock,
        "Male" to Male,
        "Man" to Man,
        "Man2" to Man2,
        "Man3" to Man3,
        "Man4" to Man4,
        "Manage Accounts" to ManageAccounts,
        "Manage History" to ManageHistory,
        "Manage Search" to ManageSearch,
        "Map" to Map,
        "Maps Ugc" to MapsUgc,
        "Margin" to Margin,
        "Mark As Unread" to MarkAsUnread,
        "Mark Chat Read" to MarkChatRead,
        "Mark Chat Unread" to MarkChatUnread,
        "Mark Email Read" to MarkEmailRead,
        "Mark Email Unread" to MarkEmailUnread,
        "Mark Unread Chat Alt" to MarkUnreadChatAlt,
        "Markunread Mailbox" to MarkunreadMailbox,
        "Masks" to Masks,
        "Maximize" to Maximize,
        "Media Bluetooth Off" to MediaBluetoothOff,
        "Media Bluetooth On" to MediaBluetoothOn,
        "Mediation" to Mediation,
        "Medical Information" to MedicalInformation,
        "Medical Services" to MedicalServices,
        "Medication" to Medication,
        "Meeting Room" to MeetingRoom,
        "Memory" to Memory,
        "Menu Book" to MenuBook,
        "Menu Open" to MenuOpen,
        "Merge" to Merge,
        "Merge Type" to MergeType,
        "Mic" to Mic,
        "Mic External Off" to MicExternalOff,
        "Mic External On" to MicExternalOn,
        "Mic Off" to MicOff,
        "Microwave" to Microwave,
        "Military Tech" to MilitaryTech,
        "Minimize" to Minimize,
        "Minor Crash" to MinorCrash,
        "Missed Video Call" to MissedVideoCall,
        "Mms" to Mms,
        "Mobile Off" to MobileOff,
        "Mobiledata Off" to MobiledataOff,
        "Mode Comment" to ModeComment,
        "Mode Fan Off" to ModeFanOff,
        "Mode Of Travel" to ModeOfTravel,
        "Mode Standby" to ModeStandby,
        "Model Training" to ModelTraining,
        "Monetization On" to MonetizationOn,
        "Money" to Money,
        "Money Off" to MoneyOff,
        "Monitor" to Monitor,
        "Monitor Heart" to MonitorHeart,
        "Monitor Weight" to MonitorWeight,
        "Monochrome Photos" to MonochromePhotos,
        "Mood" to Mood,
        "Mood Bad" to MoodBad,
        "Moped" to Moped,
        "More" to More,
        "More Horiz" to MoreHoriz,
        "More Time" to MoreTime,
        "Mosque" to Mosque,
        "Motion Photos Auto" to MotionPhotosAuto,
        "Motion Photos Off" to MotionPhotosOff,
        "Motion Photos On" to MotionPhotosOn,
        "Motion Photos Paused" to MotionPhotosPaused,
        "Motorcycle" to Motorcycle,
        "Mouse" to Mouse,
        "Move Down" to MoveDown,
        "Move To Inbox" to MoveToInbox,
        "Move Up" to MoveUp,
        "Movie" to Movie,
        "Movie Filter" to MovieFilter,
        "Moving" to Moving,
        "Mp" to Mp,
        "Multiline Chart" to MultilineChart,
        "Multiple Stop" to MultipleStop,
        "Museum" to Museum,
        "Music Note" to MusicNote,
        "Music Off" to MusicOff,
        "Music Video" to MusicVideo,
        "My Location" to MyLocation,
        "Nat" to Nat,
        "Nature" to Nature,
        "Nature People" to NaturePeople,
        "Navigation" to Navigation,
        "Near Me" to NearMe,
        "Near Me Disabled" to NearMeDisabled,
        "Nearby Error" to NearbyError,
        "Nearby Off" to NearbyOff,
        "Nest Cam Wired Stand" to NestCamWiredStand,
        "Network Cell" to NetworkCell,
        "Network Check" to NetworkCheck,
        "Network Locked" to NetworkLocked,
        "Network Ping" to NetworkPing,
        "Network Wifi" to NetworkWifi,
        "Network Wifi1 Bar" to NetworkWifi1Bar,
        "Network Wifi2 Bar" to NetworkWifi2Bar,
        "Network Wifi3 Bar" to NetworkWifi3Bar,
        "New Label" to NewLabel,
        "Newspaper" to Newspaper,
        "Next Plan" to NextPlan,
        "Next Week" to NextWeek,
        "Nfc" to Nfc,
        "Night Shelter" to NightShelter,
        "Nightlife" to Nightlife,
        "Nightlight" to Nightlight,
        "No Accounts" to NoAccounts,
        "No Adult Content" to NoAdultContent,
        "No Backpack" to NoBackpack,
        "No Crash" to NoCrash,
        "No Drinks" to NoDrinks,
        "No Encryption" to NoEncryption,
        "No Flash" to NoFlash,
        "No Food" to NoFood,
        "No Luggage" to NoLuggage,
        "No Meals" to NoMeals,
        "No Meeting Room" to NoMeetingRoom,
        "No Photography" to NoPhotography,
        "No Sim" to NoSim,
        "No Stroller" to NoStroller,
        "No Transfer" to NoTransfer,
        "Noise Aware" to NoiseAware,
        "Noise Control Off" to NoiseControlOff,
        "Nordic Walking" to NordicWalking,
        "North" to North,
        "North East" to NorthEast,
        "North West" to NorthWest,
        "Not Accessible" to NotAccessible,
        "Not Listed Location" to NotListedLocation,
        "Not Started" to NotStarted,
        "Note" to Note,
        "Note Add" to NoteAdd,
        "Note Alt" to NoteAlt,
        "Notes" to Notes,
        "Notification Add" to NotificationAdd,
        "Notification Important" to NotificationImportant,
        "Notifications Active" to NotificationsActive,
        "Notifications Off" to NotificationsOff,
        "Notifications Paused" to NotificationsPaused,
        "Numbers" to Numbers,
        "Offline Bolt" to OfflineBolt,
        "Offline Pin" to OfflinePin,
        "Oil Barrel" to OilBarrel,
        "On Device Training" to OnDeviceTraining,
        "Online Prediction" to OnlinePrediction,
        "Opacity" to Opacity,
        "Open In Browser" to OpenInBrowser,
        "Open In Full" to OpenInFull,
        "Open In New" to OpenInNew,
        "Open In New Off" to OpenInNewOff,
        "Open With" to OpenWith,
        "Other Houses" to OtherHouses,
        "Outbound" to Outbound,
        "Outbox" to Outbox,
        "Outdoor Grill" to OutdoorGrill,
        "Outlet" to Outlet,
        "Output" to Output,
        "Padding" to Padding,
        "Pages" to Pages,
        "Pageview" to Pageview,
        "Paid" to Paid,
        "Palette" to Palette,
        "Pan Tool" to PanTool,
        "Pan Tool Alt" to PanToolAlt,
        "Panorama" to Panorama,
        "Panorama Fish Eye" to PanoramaFishEye,
        "Panorama Horizontal" to PanoramaHorizontal,
        "Panorama Photosphere" to PanoramaPhotosphere,
        "Panorama Vertical" to PanoramaVertical,
        "Panorama Wide Angle" to PanoramaWideAngle,
        "Paragliding" to Paragliding,
        "Park" to Park,
        "Party Mode" to PartyMode,
        "Password" to Password,
        "Pattern" to Pattern,
        "Pause" to Pause,
        "Pause Circle" to PauseCircle,
        "Pause Presentation" to PausePresentation,
        "Payments" to Payments,
        "Pedal Bike" to PedalBike,
        "Pending" to Pending,
        "Pending Actions" to PendingActions,
        "Pentagon" to Pentagon,
        "Percent" to Percent,
        "Perm Camera Mic" to PermCameraMic,
        "Perm Contact Calendar" to PermContactCalendar,
        "Perm Data Setting" to PermDataSetting,
        "Perm Media" to PermMedia,
        "Perm Phone Msg" to PermPhoneMsg,
        "Perm Scan Wifi" to PermScanWifi,
        "Person2" to Person2,
        "Person3" to Person3,
        "Person4" to Person4,
        "Person Add" to PersonAdd,
        "Person Add Disabled" to PersonAddDisabled,
        "Person Off" to PersonOff,
        "Person Pin" to PersonPin,
        "Person Pin Circle" to PersonPinCircle,
        "Person Remove" to PersonRemove,
        "Person Search" to PersonSearch,
        "Personal Injury" to PersonalInjury,
        "Pest Control" to PestControl,
        "Pest Control Rodent" to PestControlRodent,
        "Pets" to Pets,
        "Phishing" to Phishing,
        "Phone Bluetooth Speaker" to PhoneBluetoothSpeaker,
        "Phone Callback" to PhoneCallback,
        "Phone Disabled" to PhoneDisabled,
        "Phone Enabled" to PhoneEnabled,
        "Phone Forwarded" to PhoneForwarded,
        "Phone In Talk" to PhoneInTalk,
        "Phone Locked" to PhoneLocked,
        "Phone Missed" to PhoneMissed,
        "Phone Paused" to PhonePaused,
        "Photo" to Photo,
        "Photo Album" to PhotoAlbum,
        "Photo Camera" to PhotoCamera,
        "Photo Camera Back" to PhotoCameraBack,
        "Photo Camera Front" to PhotoCameraFront,
        "Photo Filter" to PhotoFilter,
        "Photo Library" to PhotoLibrary,
        "Photo Size Select Large" to PhotoSizeSelectLarge,
        "Photo Size Select Small" to PhotoSizeSelectSmall,
        "Php" to Php,
        "Piano" to Piano,
        "Piano Off" to PianoOff,
        "Picture As Pdf" to PictureAsPdf,
        "Picture In Picture" to PictureInPicture,
        "Picture In Picture Alt" to PictureInPictureAlt,
        "Pie Chart" to PieChart,
        "Pin" to Pin,
        "Pin Drop" to PinDrop,
        "Pin End" to PinEnd,
        "Pin Invoke" to PinInvoke,
        "Pinch" to Pinch,
        "Pivot Table Chart" to PivotTableChart,
        "Plagiarism" to Plagiarism,
        "Play Circle" to PlayCircle,
        "Play Disabled" to PlayDisabled,
        "Play For Work" to PlayForWork,
        "Play Lesson" to PlayLesson,
        "Playlist Add" to PlaylistAdd,
        "Playlist Add Check" to PlaylistAddCheck,
        "Playlist Add Check Circle" to PlaylistAddCheckCircle,
        "Playlist Add Circle" to PlaylistAddCircle,
        "Playlist Play" to PlaylistPlay,
        "Playlist Remove" to PlaylistRemove,
        "Plumbing" to Plumbing,
        "Podcasts" to Podcasts,
        "Point Of Sale" to PointOfSale,
        "Policy" to Policy,
        "Polyline" to Polyline,
        "Polymer" to Polymer,
        "Pool" to Pool,
        "Post Add" to PostAdd,
        "Power" to Power,
        "Power Input" to PowerInput,
        "Power Off" to PowerOff,
        "Power Settings New" to PowerSettingsNew,
        "Precision Manufacturing" to PrecisionManufacturing,
        "Present To All" to PresentToAll,
        "Preview" to Preview,
        "Price Change" to PriceChange,
        "Price Check" to PriceCheck,
        "Print" to Print,
        "Print Disabled" to PrintDisabled,
        "Priority High" to PriorityHigh,
        "Privacy Tip" to PrivacyTip,
        "Private Connectivity" to PrivateConnectivity,
        "Production Quantity Limits" to ProductionQuantityLimits,
        "Propane" to Propane,
        "Propane Tank" to PropaneTank,
        "Psychology" to Psychology,
        "Psychology Alt" to PsychologyAlt,
        "Public" to Public,
        "Public Off" to PublicOff,
        "Publish" to Publish,
        "Published With Changes" to PublishedWithChanges,
        "Punch Clock" to PunchClock,
        "Push Pin" to PushPin,
        "Qr Code" to QrCode,
        "Qr Code2" to QrCode2,
        "Qr Code Scanner" to QrCodeScanner,
        "Query Stats" to QueryStats,
        "Question Mark" to QuestionMark,
        "Queue Music" to QueueMusic,
        "Queue Play Next" to QueuePlayNext,
        "Quickreply" to Quickreply,
        "Quiz" to Quiz,
        "R Mobiledata" to RMobiledata,
        "Radar" to Radar,
        "Radio" to Radio,
        "Radio Button Checked" to RadioButtonChecked,
        "Radio Button Unchecked" to RadioButtonUnchecked,
        "Railway Alert" to RailwayAlert,
        "Ramen Dining" to RamenDining,
        "Ramp Left" to RampLeft,
        "Ramp Right" to RampRight,
        "Rate Review" to RateReview,
        "Raw Off" to RawOff,
        "Raw On" to RawOn,
        "Read More" to ReadMore,
        "Real Estate Agent" to RealEstateAgent,
        "Receipt" to Receipt,
        "Receipt Long" to ReceiptLong,
        "Recent Actors" to RecentActors,
        "Recommend" to Recommend,
        "Record Voice Over" to RecordVoiceOver,
        "Rectangle" to Rectangle,
        "Recycling" to Recycling,
        "Redeem" to Redeem,
        "Redo" to Redo,
        "Reduce Capacity" to ReduceCapacity,
        "Remember Me" to RememberMe,
        "Remove" to Remove,
        "Remove Done" to RemoveDone,
        "Remove From Queue" to RemoveFromQueue,
        "Remove Moderator" to RemoveModerator,
        "Remove Road" to RemoveRoad,
        "Remove Shopping Cart" to RemoveShoppingCart,
        "Reorder" to Reorder,
        "Repartition" to Repartition,
        "Repeat" to Repeat,
        "Repeat On" to RepeatOn,
        "Repeat One" to RepeatOne,
        "Repeat One On" to RepeatOneOn,
        "Replay" to Replay,
        "Replay10" to Replay10,
        "Replay30" to Replay30,
        "Replay5" to Replay5,
        "Replay Circle Filled" to ReplayCircleFilled,
        "Reply" to Reply,
        "Reply All" to ReplyAll,
        "Report" to Report,
        "Report Off" to ReportOff,
        "Request Page" to RequestPage,
        "Request Quote" to RequestQuote,
        "Reset Tv" to ResetTv,
        "Restart Alt" to RestartAlt,
        "Restaurant" to Restaurant,
        "Restaurant Menu" to RestaurantMenu,
        "Restore From Trash" to RestoreFromTrash,
        "Restore Page" to RestorePage,
        "Reviews" to Reviews,
        "Rice Bowl" to RiceBowl,
        "Ring Volume" to RingVolume,
        "Rocket" to Rocket,
        "Rocket Launch" to RocketLaunch,
        "Roller Shades" to RollerShades,
        "Roller Shades Closed" to RollerShadesClosed,
        "Roller Skating" to RollerSkating,
        "Roofing" to Roofing,
        "Room Preferences" to RoomPreferences,
        "Room Service" to RoomService,
        "Rotate90 Degrees Ccw" to Rotate90DegreesCcw,
        "Rotate90 Degrees Cw" to Rotate90DegreesCw,
        "Rotate Left" to RotateLeft,
        "Rotate Right" to RotateRight,
        "Roundabout Left" to RoundaboutLeft,
        "Roundabout Right" to RoundaboutRight,
        "Rounded Corner" to RoundedCorner,
        "Route" to Route,
        "Router" to Router,
        "Rowing" to Rowing,
        "Rss Feed" to RssFeed,
        "Rsvp" to Rsvp,
        "Rtt" to Rtt,
        "Rule" to Rule,
        "Rule Folder" to RuleFolder,
        "Run Circle" to RunCircle,
        "Running With Errors" to RunningWithErrors,
        "Rv Hookup" to RvHookup,
        "Safety Check" to SafetyCheck,
        "Safety Divider" to SafetyDivider,
        "Sailing" to Sailing,
        "Sanitizer" to Sanitizer,
        "Satellite" to Satellite,
        "Satellite Alt" to SatelliteAlt,
        "Save" to Save,
        "Save As" to SaveAs,
        "Saved Search" to SavedSearch,
        "Savings" to Savings,
        "Scale" to Scale,
        "Scanner" to Scanner,
        "Scatter Plot" to ScatterPlot,
        "Schedule" to Schedule,
        "Schedule Send" to ScheduleSend,
        "Schema" to Schema,
        "School" to School,
        "Science" to Science,
        "Score" to Score,
        "Scoreboard" to Scoreboard,
        "Screen Rotation Alt" to ScreenRotationAlt,
        "Screen Search Desktop" to ScreenSearchDesktop,
        "Screen Share" to ScreenShare,
        "Screenshot" to Screenshot,
        "Screenshot Monitor" to ScreenshotMonitor,
        "Scuba Diving" to ScubaDiving,
        "Sd" to Sd,
        "Sd Card" to SdCard,
        "Sd Card Alert" to SdCardAlert,
        "Search Off" to SearchOff,
        "Security" to Security,
        "Segment" to Segment,
        "Select All" to SelectAll,
        "Self Improvement" to SelfImprovement,
        "Sell" to Sell,
        "Send And Archive" to SendAndArchive,
        "Send Time Extension" to SendTimeExtension,
        "Sensor Door" to SensorDoor,
        "Sensor Occupied" to SensorOccupied,
        "Sensor Window" to SensorWindow,
        "Sensors" to Sensors,
        "Sensors Off" to SensorsOff,
        "Sentiment Dissatisfied" to SentimentDissatisfied,
        "Sentiment Neutral" to SentimentNeutral,
        "Sentiment Satisfied" to SentimentSatisfied,
        "Sentiment Very Dissatisfied" to SentimentVeryDissatisfied,
        "Sentiment Very Satisfied" to SentimentVerySatisfied,
        "Set Meal" to SetMeal,
        "Settings Accessibility" to SettingsAccessibility,
        "Settings Applications" to SettingsApplications,
        "Settings Backup Restore" to SettingsBackupRestore,
        "Settings Bluetooth" to SettingsBluetooth,
        "Settings Brightness" to SettingsBrightness,
        "Settings Ethernet" to SettingsEthernet,
        "Settings Input Antenna" to SettingsInputAntenna,
        "Settings Input Component" to SettingsInputComponent,
        "Settings Input Hdmi" to SettingsInputHdmi,
        "Settings Input Svideo" to SettingsInputSvideo,
        "Settings Overscan" to SettingsOverscan,
        "Settings Phone" to SettingsPhone,
        "Settings Power" to SettingsPower,
        "Settings Remote" to SettingsRemote,
        "Settings Suggest" to SettingsSuggest,
        "Settings System Daydream" to SettingsSystemDaydream,
        "Settings Voice" to SettingsVoice,
        "Severe Cold" to SevereCold,
        "Shape Line" to ShapeLine,
        "Share Location" to ShareLocation,
        "Shield" to Shield,
        "Shield Moon" to ShieldMoon,
        "Shop" to Shop,
        "Shop Two" to ShopTwo,
        "Shopping Bag" to ShoppingBag,
        "Shopping Basket" to ShoppingBasket,
        "Shopping Cart Checkout" to ShoppingCartCheckout,
        "Short Text" to ShortText,
        "Show Chart" to ShowChart,
        "Shower" to Shower,
        "Shuffle" to Shuffle,
        "Shuffle On" to ShuffleOn,
        "Shutter Speed" to ShutterSpeed,
        "Sick" to Sick,
        "Sign Language" to SignLanguage,
        "Signal Cellular0 Bar" to SignalCellular0Bar,
        "Signal Cellular4 Bar" to SignalCellular4Bar,
        "Signal Cellular Alt" to SignalCellularAlt,
        "Signal Cellular Alt1 Bar" to SignalCellularAlt1Bar,
        "Signal Cellular Alt2 Bar" to SignalCellularAlt2Bar,
        "Signal Cellular Connected No Internet0 Bar" to SignalCellularConnectedNoInternet0Bar,
        "Signal Cellular Connected No Internet4 Bar" to SignalCellularConnectedNoInternet4Bar,
        "Signal Cellular Nodata" to SignalCellularNodata,
        "Signal Cellular Null" to SignalCellularNull,
        "Signal Cellular Off" to SignalCellularOff,
        "Signal Wifi0 Bar" to SignalWifi0Bar,
        "Signal Wifi4 Bar" to SignalWifi4Bar,
        "Signal Wifi Bad" to SignalWifiBad,
        "Signal Wifi Off" to SignalWifiOff,
        "Signal Wifi Statusbar Null" to SignalWifiStatusbarNull,
        "Signpost" to Signpost,
        "Sim Card" to SimCard,
        "Sim Card Download" to SimCardDownload,
        "Single Bed" to SingleBed,
        "Sip" to Sip,
        "Skateboarding" to Skateboarding,
        "Skip Next" to SkipNext,
        "Skip Previous" to SkipPrevious,
        "Sledding" to Sledding,
        "Slideshow" to Slideshow,
        "Slow Motion Video" to SlowMotionVideo,
        "Smart Button" to SmartButton,
        "Smart Display" to SmartDisplay,
        "Smart Toy" to SmartToy,
        "Smoke Free" to SmokeFree,
        "Smoking Rooms" to SmokingRooms,
        "Sms" to Sms,
        "Sms Failed" to SmsFailed,
        "Snippet Folder" to SnippetFolder,
        "Snooze" to Snooze,
        "Snowboarding" to Snowboarding,
        "Snowmobile" to Snowmobile,
        "Snowshoeing" to Snowshoeing,
        "Soap" to Soap,
        "Social Distance" to SocialDistance,
        "Solar Power" to SolarPower,
        "Sort" to Sort,
        "Sort By Alpha" to SortByAlpha,
        "Sos" to Sos,
        "Soup Kitchen" to SoupKitchen,
        "South" to South,
        "South America" to SouthAmerica,
        "South East" to SouthEast,
        "South West" to SouthWest,
        "Spa" to Spa,
        "Space Bar" to SpaceBar,
        "Space Dashboard" to SpaceDashboard,
        "Spatial Audio" to SpatialAudio,
        "Spatial Audio Off" to SpatialAudioOff,
        "Spatial Tracking" to SpatialTracking,
        "Speaker" to Speaker,
        "Speaker Group" to SpeakerGroup,
        "Speaker Notes" to SpeakerNotes,
        "Speaker Notes Off" to SpeakerNotesOff,
        "Speaker Phone" to SpeakerPhone,
        "Speed" to Speed,
        "Spellcheck" to Spellcheck,
        "Splitscreen" to Splitscreen,
        "Spoke" to Spoke,
        "Sports" to Sports,
        "Sports Bar" to SportsBar,
        "Sports Baseball" to SportsBaseball,
        "Sports Basketball" to SportsBasketball,
        "Sports Cricket" to SportsCricket,
        "Sports Esports" to SportsEsports,
        "Sports Football" to SportsFootball,
        "Sports Golf" to SportsGolf,
        "Sports Gymnastics" to SportsGymnastics,
        "Sports Handball" to SportsHandball,
        "Sports Hockey" to SportsHockey,
        "Sports Kabaddi" to SportsKabaddi,
        "Sports Martial Arts" to SportsMartialArts,
        "Sports Mma" to SportsMma,
        "Sports Motorsports" to SportsMotorsports,
        "Sports Rugby" to SportsRugby,
        "Sports Score" to SportsScore,
        "Sports Soccer" to SportsSoccer,
        "Sports Tennis" to SportsTennis,
        "Sports Volleyball" to SportsVolleyball,
        "Square" to Square,
        "Square Foot" to SquareFoot,
        "Ssid Chart" to SsidChart,
        "Stacked Bar Chart" to StackedBarChart,
        "Stacked Line Chart" to StackedLineChart,
        "Stadium" to Stadium,
        "Stairs" to Stairs,
        "Star Half" to StarHalf,
        "Star Rate" to StarRate,
        "Stars" to Stars,
        "Start" to Start,
        "Sticky Note2" to StickyNote2,
        "Stop" to Stop,
        "Stop Circle" to StopCircle,
        "Stop Screen Share" to StopScreenShare,
        "Storage" to Storage,
        "Store" to Store,
        "Storefront" to Storefront,
        "Storm" to Storm,
        "Straight" to Straight,
        "Straighten" to Straighten,
        "Stream" to Stream,
        "Streetview" to Streetview,
        "Strikethrough S" to StrikethroughS,
        "Stroller" to Stroller,
        "Style" to Style,
        "Subdirectory Arrow Left" to SubdirectoryArrowLeft,
        "Subdirectory Arrow Right" to SubdirectoryArrowRight,
        "Subject" to Subject,
        "Subscript" to Subscript,
        "Subscriptions" to Subscriptions,
        "Subtitles" to Subtitles,
        "Subtitles Off" to SubtitlesOff,
        "Subway" to Subway,
        "Summarize" to Summarize,
        "Superscript" to Superscript,
        "Supervised User Circle" to SupervisedUserCircle,
        "Supervisor Account" to SupervisorAccount,
        "Support" to Support,
        "Support Agent" to SupportAgent,
        "Surfing" to Surfing,
        "Surround Sound" to SurroundSound,
        "Swap Calls" to SwapCalls,
        "Swap Horiz" to SwapHoriz,
        "Swap Horizontal Circle" to SwapHorizontalCircle,
        "Swap Vert" to SwapVert,
        "Swap Vertical Circle" to SwapVerticalCircle,
        "Swipe" to Swipe,
        "Swipe Down" to SwipeDown,
        "Swipe Down Alt" to SwipeDownAlt,
        "Swipe Left" to SwipeLeft,
        "Swipe Left Alt" to SwipeLeftAlt,
        "Swipe Right" to SwipeRight,
        "Swipe Right Alt" to SwipeRightAlt,
        "Swipe Up" to SwipeUp,
        "Swipe Up Alt" to SwipeUpAlt,
        "Swipe Vertical" to SwipeVertical,
        "Switch Access Shortcut" to SwitchAccessShortcut,
        "Switch Access Shortcut Add" to SwitchAccessShortcutAdd,
        "Switch Account" to SwitchAccount,
        "Switch Camera" to SwitchCamera,
        "Switch Left" to SwitchLeft,
        "Switch Right" to SwitchRight,
        "Switch Video" to SwitchVideo,
        "Synagogue" to Synagogue,
        "Sync" to Sync,
        "Sync Alt" to SyncAlt,
        "Sync Disabled" to SyncDisabled,
        "Sync Lock" to SyncLock,
        "Sync Problem" to SyncProblem,
        "System Update Alt" to SystemUpdateAlt,
        "Tab" to Tab,
        "Tab Unselected" to TabUnselected,
        "Table Bar" to TableBar,
        "Table Chart" to TableChart,
        "Table Restaurant" to TableRestaurant,
        "Table Rows" to TableRows,
        "Table View" to TableView,
        "Tablet" to Tablet,
        "Tablet Android" to TabletAndroid,
        "Tablet Mac" to TabletMac,
        "Tag" to Tag,
        "Takeout Dining" to TakeoutDining,
        "Tapas" to Tapas,
        "Task" to Task,
        "Task Alt" to TaskAlt,
        "Taxi Alert" to TaxiAlert,
        "Temple Buddhist" to TempleBuddhist,
        "Temple Hindu" to TempleHindu,
        "Terminal" to Terminal,
        "Text Decrease" to TextDecrease,
        "Text Fields" to TextFields,
        "Text Format" to TextFormat,
        "Text Increase" to TextIncrease,
        "Text Rotate Up" to TextRotateUp,
        "Text Rotate Vertical" to TextRotateVertical,
        "Text Rotation Angledown" to TextRotationAngledown,
        "Text Rotation Angleup" to TextRotationAngleup,
        "Text Rotation Down" to TextRotationDown,
        "Text Rotation None" to TextRotationNone,
        "Text Snippet" to TextSnippet,
        "Texture" to Texture,
        "Theater Comedy" to TheaterComedy,
        "Theaters" to Theaters,
        "Thermostat" to Thermostat,
        "Thermostat Auto" to ThermostatAuto,
        "Thumb Down" to ThumbDown,
        "Thumbs Up Down" to ThumbsUpDown,
        "Thunderstorm" to Thunderstorm,
        "Timelapse" to Timelapse,
        "Timeline" to Timeline,
        "Timer" to Timer,
        "Timer10" to Timer10,
        "Timer10 Select" to Timer10Select,
        "Timer3" to Timer3,
        "Timer3 Select" to Timer3Select,
        "Timer Off" to TimerOff,
        "Tips And Updates" to TipsAndUpdates,
        "Tire Repair" to TireRepair,
        "Title" to Title,
        "Toc" to Toc,
        "Today" to Today,
        "Toggle Off" to ToggleOff,
        "Toggle On" to ToggleOn,
        "Token" to Token,
        "Toll" to Toll,
        "Tonality" to Tonality,
        "Topic" to Topic,
        "Tornado" to Tornado,
        "Touch App" to TouchApp,
        "Tour" to Tour,
        "Toys" to Toys,
        "Track Changes" to TrackChanges,
        "Traffic" to Traffic,
        "Train" to Train,
        "Tram" to Tram,
        "Transcribe" to Transcribe,
        "Transfer Within A Station" to TransferWithinAStation,
        "Transform" to Transform,
        "Transgender" to Transgender,
        "Transit Enterexit" to TransitEnterexit,
        "Translate" to Translate,
        "Travel Explore" to TravelExplore,
        "Trending Down" to TrendingDown,
        "Trending Flat" to TrendingFlat,
        "Trending Up" to TrendingUp,
        "Trip Origin" to TripOrigin,
        "Troubleshoot" to Troubleshoot,
        "Tsunami" to Tsunami,
        "Tty" to Tty,
        "Tune" to Tune,
        "Turn Left" to TurnLeft,
        "Turn Right" to TurnRight,
        "Turn Sharp Left" to TurnSharpLeft,
        "Turn Sharp Right" to TurnSharpRight,
        "Turn Slight Left" to TurnSlightLeft,
        "Turn Slight Right" to TurnSlightRight,
        "Tv" to Tv,
        "Tv Off" to TvOff,
        "Two Wheeler" to TwoWheeler,
        "Type Specimen" to TypeSpecimen,
        "U Turn Left" to UTurnLeft,
        "U Turn Right" to UTurnRight,
        "Umbrella" to Umbrella,
        "Unarchive" to Unarchive,
        "Undo" to Undo,
        "Unfold Less" to UnfoldLess,
        "Unfold Less Double" to UnfoldLessDouble,
        "Unfold More" to UnfoldMore,
        "Unfold More Double" to UnfoldMoreDouble,
        "Unpublished" to Unpublished,
        "Unsubscribe" to Unsubscribe,
        "Upcoming" to Upcoming,
        "Update" to Update,
        "Update Disabled" to UpdateDisabled,
        "Upgrade" to Upgrade,
        "Upload" to Upload,
        "Upload File" to UploadFile,
        "Usb" to Usb,
        "Usb Off" to UsbOff,
        "Vaccines" to Vaccines,
        "Vape Free" to VapeFree,
        "Vaping Rooms" to VapingRooms,
        "Verified" to Verified,
        "Verified User" to VerifiedUser,
        "Vertical Align Bottom" to VerticalAlignBottom,
        "Vertical Align Center" to VerticalAlignCenter,
        "Vertical Align Top" to VerticalAlignTop,
        "Vertical Distribute" to VerticalDistribute,
        "Vertical Shades" to VerticalShades,
        "Vertical Shades Closed" to VerticalShadesClosed,
        "Vertical Split" to VerticalSplit,
        "Video Call" to VideoCall,
        "Video Camera Back" to VideoCameraBack,
        "Video Camera Front" to VideoCameraFront,
        "Video Chat" to VideoChat,
        "Video File" to VideoFile,
        "Video Label" to VideoLabel,
        "Video Library" to VideoLibrary,
        "Video Settings" to VideoSettings,
        "Video Stable" to VideoStable,
        "Videocam" to Videocam,
        "Videocam Off" to VideocamOff,
        "Videogame Asset" to VideogameAsset,
        "Videogame Asset Off" to VideogameAssetOff,
        "View Agenda" to ViewAgenda,
        "View Array" to ViewArray,
        "View Carousel" to ViewCarousel,
        "View Column" to ViewColumn,
        "View Comfy" to ViewComfy,
        "View Comfy Alt" to ViewComfyAlt,
        "View Compact" to ViewCompact,
        "View Compact Alt" to ViewCompactAlt,
        "View Cozy" to ViewCozy,
        "View Day" to ViewDay,
        "View Headline" to ViewHeadline,
        "View In Ar" to ViewInAr,
        "View Kanban" to ViewKanban,
        "View List" to ViewList,
        "View Module" to ViewModule,
        "View Quilt" to ViewQuilt,
        "View Sidebar" to ViewSidebar,
        "View Stream" to ViewStream,
        "View Timeline" to ViewTimeline,
        "View Week" to ViewWeek,
        "Vignette" to Vignette,
        "Villa" to Villa,
        "Visibility" to Visibility,
        "Visibility Off" to VisibilityOff,
        "Voice Chat" to VoiceChat,
        "Voice Over Off" to VoiceOverOff,
        "Voicemail" to Voicemail,
        "Volcano" to Volcano,
        "Volume Down" to VolumeDown,
        "Volume Mute" to VolumeMute,
        "Volume Off" to VolumeOff,
        "Volume Up" to VolumeUp,
        "Volunteer Activism" to VolunteerActivism,
        "Vpn Key" to VpnKey,
        "Vpn Key Off" to VpnKeyOff,
        "Vpn Lock" to VpnLock,
        "Vrpano" to Vrpano,
        "Wallet" to Wallet,
        "Wallpaper" to Wallpaper,
        "Warehouse" to Warehouse,
        "Wash" to Wash,
        "Watch" to Watch,
        "Watch Off" to WatchOff,
        "Water" to Water,
        "Water Damage" to WaterDamage,
        "Water Drop" to WaterDrop,
        "Waterfall Chart" to WaterfallChart,
        "Waves" to Waves,
        "Waving Hand" to WavingHand,
        "Wb Auto" to WbAuto,
        "Wb Incandescent" to WbIncandescent,
        "Wb Iridescent" to WbIridescent,
        "Wb Shade" to WbShade,
        "Wb Sunny" to WbSunny,
        "Wb Twilight" to WbTwilight,
        "Wc" to Wc,
        "Web" to Web,
        "Web Asset" to WebAsset,
        "Web Asset Off" to WebAssetOff,
        "Web Stories" to WebStories,
        "Webhook" to Webhook,
        "Weekend" to Weekend,
        "West" to West,
        "Whatshot" to Whatshot,
        "Wheelchair Pickup" to WheelchairPickup,
        "Where To Vote" to WhereToVote,
        "Widgets" to Widgets,
        "Width Full" to WidthFull,
        "Width Normal" to WidthNormal,
        "Width Wide" to WidthWide,
        "Wifi" to Wifi,
        "Wifi1 Bar" to Wifi1Bar,
        "Wifi2 Bar" to Wifi2Bar,
        "Wifi Calling" to WifiCalling,
        "Wifi Channel" to WifiChannel,
        "Wifi Find" to WifiFind,
        "Wifi Lock" to WifiLock,
        "Wifi Off" to WifiOff,
        "Wifi Password" to WifiPassword,
        "Wifi Protected Setup" to WifiProtectedSetup,
        "Wifi Tethering" to WifiTethering,
        "Wifi Tethering Error" to WifiTetheringError,
        "Wifi Tethering Off" to WifiTetheringOff,
        "Wind Power" to WindPower,
        "Window" to Window,
        "Wine Bar" to WineBar,
        "Woman" to Woman,
        "Woman2" to Woman2,
        "Work" to Work,
        "Work History" to WorkHistory,
        "Work Off" to WorkOff,
        "Workspace Premium" to WorkspacePremium,
        "Workspaces" to Workspaces,
        "Wrap Text" to WrapText,
        "Wrong Location" to WrongLocation,
        "Wysiwyg" to Wysiwyg,
        "Yard" to Yard,
        "Youtube Searched For" to YoutubeSearchedFor,
        "Zoom In" to ZoomIn,
        "Zoom In Map" to ZoomInMap,
        "Zoom Out" to ZoomOut,
        "Zoom Out Map" to ZoomOutMap,
        "10k" to _10k,
        "10mp" to _10mp,
        "11mp" to _11mp,
        "123" to _123,
        "12mp" to _12mp,
        "13mp" to _13mp,
        "14mp" to _14mp,
        "15mp" to _15mp,
        "16mp" to _16mp,
        "17mp" to _17mp,
        "18 Up Rating" to _18UpRating,
        "18mp" to _18mp,
        "19mp" to _19mp,
        "1k" to _1k,
        "1k Plus" to _1kPlus,
        "1x Mobiledata" to _1xMobiledata,
        "20mp" to _20mp,
        "21mp" to _21mp,
        "22mp" to _22mp,
        "23mp" to _23mp,
        "24mp" to _24mp,
        "2k" to _2k,
        "2k Plus" to _2kPlus,
        "2mp" to _2mp,
        "30fps" to _30fps,
        "30fps Select" to _30fpsSelect,
        "360" to _360,
        "3d Rotation" to _3dRotation,
        "3g Mobiledata" to _3gMobiledata,
        "3k" to _3k,
        "3k Plus" to _3kPlus,
        "3mp" to _3mp,
        "3p" to _3p,
        "4g Mobiledata" to _4gMobiledata,
        "4g Plus Mobiledata" to _4gPlusMobiledata,
        "4k" to _4k,
        "4k Plus" to _4kPlus,
        "4mp" to _4mp,
        "5g" to _5g,
        "5k" to _5k,
        "5k Plus" to _5kPlus,
        "5mp" to _5mp,
        "60fps" to _60fps,
        "60fps Select" to _60fpsSelect,
        "6 Ft Apart" to _6FtApart,
        "6k" to _6k,
        "6k Plus" to _6kPlus,
        "6mp" to _6mp,
        "7k" to _7k,
        "7k Plus" to _7kPlus,
        "7mp" to _7mp,
        "8k" to _8k,
        "8k Plus" to _8kPlus,
        "8mp" to _8mp,
        "9k" to _9k,
        "9k Plus" to _9kPlus,
        "9mp" to _9mp,
    )
}

val extendedOnlyAutoMirroredFilledIconNamePairs: List<Pair<String, Icon>> = with(Icons.AutoMirrored.Filled) {
    listOf(
        "Accessible" to Accessible,
        "Accessible Forward" to AccessibleForward,
        "Airplane Ticket" to AirplaneTicket,
        "Align Horizontal Left" to AlignHorizontalLeft,
        "Align Horizontal Right" to AlignHorizontalRight,
        "Alt Route" to AltRoute,
        "Arrow Back Ios" to ArrowBackIos,
        "Arrow Forward Ios" to ArrowForwardIos,
        "Arrow Left" to ArrowLeft,
        "Arrow Right" to ArrowRight,
        "Arrow Right Alt" to ArrowRightAlt,
        "Article" to Article,
        "Assignment" to Assignment,
        "Assignment Return" to AssignmentReturn,
        "Assistant Direction" to AssistantDirection,
        "Backspace" to Backspace,
        "Battery Unknown" to BatteryUnknown,
        "Bluetooth Searching" to BluetoothSearching,
        "Branding Watermark" to BrandingWatermark,
        "Call Made" to CallMade,
        "Call Merge" to CallMerge,
        "Call Missed" to CallMissed,
        "Call Missed Outgoing" to CallMissedOutgoing,
        "Call Received" to CallReceived,
        "Call Split" to CallSplit,
        "Chat" to Chat,
        "Chrome Reader Mode" to ChromeReaderMode,
        "Comment" to Comment,
        "Compare Arrows" to CompareArrows,
        "Contact Support" to ContactSupport,
        "Directions Bike" to DirectionsBike,
        "Directions Run" to DirectionsRun,
        "Directions Walk" to DirectionsWalk,
        "Drive File Move" to DriveFileMove,
        "Dvr" to Dvr,
        "Event Note" to EventNote,
        "Fact Check" to FactCheck,
        "Featured Play List" to FeaturedPlayList,
        "Featured Video" to FeaturedVideo,
        "Feed" to Feed,
        "Follow The Signs" to FollowTheSigns,
        "Format Align Left" to FormatAlignLeft,
        "Format Align Right" to FormatAlignRight,
        "Format Indent Decrease" to FormatIndentDecrease,
        "Format Indent Increase" to FormatIndentIncrease,
        "Format List Bulleted" to FormatListBulleted,
        "Format Textdirection L To R" to FormatTextdirectionLToR,
        "Format Textdirection R To L" to FormatTextdirectionRToL,
        "Forward" to Forward,
        "Forward To Inbox" to ForwardToInbox,
        "Grading" to Grading,
        "Help" to Help,
        "Help Center" to HelpCenter,
        "Input" to Input,
        "Keyboard Backspace" to KeyboardBackspace,
        "Keyboard Return" to KeyboardReturn,
        "Keyboard Tab" to KeyboardTab,
        "Label" to Label,
        "Label Important" to LabelImportant,
        "Label Off" to LabelOff,
        "Last Page" to LastPage,
        "Library Books" to LibraryBooks,
        "List Alt" to ListAlt,
        "Live Help" to LiveHelp,
        "Login" to Login,
        "Logout" to Logout,
        "Manage Search" to ManageSearch,
        "Menu Book" to MenuBook,
        "Menu Open" to MenuOpen,
        "Merge Type" to MergeType,
        "Missed Video Call" to MissedVideoCall,
        "More" to More,
        "Multiline Chart" to MultilineChart,
        "Next Plan" to NextPlan,
        "Next Week" to NextWeek,
        "Not Listed Location" to NotListedLocation,
        "Note" to Note,
        "Note Add" to NoteAdd,
        "Notes" to Notes,
        "Open In New" to OpenInNew,
        "Outbound" to Outbound,
        "Phone Callback" to PhoneCallback,
        "Phone Forwarded" to PhoneForwarded,
        "Phone Missed" to PhoneMissed,
        "Playlist Add" to PlaylistAdd,
        "Playlist Add Check" to PlaylistAddCheck,
        "Playlist Play" to PlaylistPlay,
        "Queue Music" to QueueMusic,
        "Read More" to ReadMore,
        "Receipt Long" to ReceiptLong,
        "Redo" to Redo,
        "Reply" to Reply,
        "Reply All" to ReplyAll,
        "Rotate Left" to RotateLeft,
        "Rotate Right" to RotateRight,
        "Rtt" to Rtt,
        "Rule" to Rule,
        "Schedule Send" to ScheduleSend,
        "Screen Share" to ScreenShare,
        "Segment" to Segment,
        "Send And Archive" to SendAndArchive,
        "Short Text" to ShortText,
        "Show Chart" to ShowChart,
        "Sort" to Sort,
        "Speaker Notes" to SpeakerNotes,
        "Star Half" to StarHalf,
        "Sticky Note2" to StickyNote2,
        "Stop Screen Share" to StopScreenShare,
        "Subject" to Subject,
        "Text Snippet" to TextSnippet,
        "Toc" to Toc,
        "Trending Down" to TrendingDown,
        "Trending Flat" to TrendingFlat,
        "Trending Up" to TrendingUp,
        "Undo" to Undo,
        "View List" to ViewList,
        "View Quilt" to ViewQuilt,
        "View Sidebar" to ViewSidebar,
        "Volume Down" to VolumeDown,
        "Volume Mute" to VolumeMute,
        "Volume Off" to VolumeOff,
        "Volume Up" to VolumeUp,
        "Wrap Text" to WrapText,
        "Wysiwyg" to Wysiwyg,
        "360" to _360,
    )
}
